import store from "../../store/store"
import { NewslineHub } from "../hubs/newsline"

export const newslineHub = new NewslineHub(store)
